export default "__VITE_ASSET__B_P3AR_u__"